import React, {useState } from 'react'
import courseLearnStyles from '../../pages/course/course-learn.module.less'
import { Col,  message, Row} from 'antd'
import * as constants from '../../constants/constants'
import { secTotime } from '../../utils/timeUtils'
import { sendHttpPostRequest } from '../../api/http-request'
import Cookies from 'js-cookie'

import CommonModal from '../modal/CommonModal/CommonModal'

import slidesStyles from '../../pages/course/slides/course-main-teacher-slides.module.less'

import Icon from '@ant-design/icons'
import  {ReactComponent as clockSvg }   from '../../static/image/course/clock-gray.svg'
const clockIcon = (props:any) => (<Icon component={clockSvg} {...props} />)
import  {ReactComponent as mydeleteSvg }   from '../../static/image/course/mydelete.svg'
const mydeleteIcon = (props:any) => (<Icon component={mydeleteSvg} {...props} />)

import  {ReactComponent as editSvg }   from '../../static/image/module/edit.svg'
import TextArea from 'antd/lib/input/TextArea'
const editIcon = (props:any) => (<Icon component={editSvg} {...props} />)


interface NoteItemProps {
  note: any
  nIdx: number
  noteList: any
  setNoteList: any
  courseId: any
  knowId: any
  jumpCurrentTime: any
  actionCallback: any
  type: any
  noHide?: boolean
}
const emoji = require('markdown-it-emoji')
export const NoteItem: React.FC<NoteItemProps> = (props) => {
  const {
    note,
    nIdx,
    noteList,
    setNoteList,
    courseId,
    knowId,
    jumpCurrentTime,
    actionCallback,
    type,
    noHide,
  } = props

  const [editorVis, setEditorVis] = useState(note.is_editor)
  const [isEdit, setIsEdit] = useState(false)
  const [deleteNoteModalVis, setDeleteNoteModalVis] = useState(false)

  const onNoteSave = () => {
    if (!noteList[nIdx].content) {
      message.error('笔记内容不能为空')
      return
    }
    if (!isEdit) {
      sendHttpPostRequest(
        'course/api/study_note/create_note/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          course_id: courseId,
          know_id: knowId,
          hash_id: note.hash_id,
          content: note.content,
          // image_id:note.image_id
        },
        (res) => {
          if (res.is_ok) {
            actionCallback(knowId)
            message.success('笔记保存成功！')
          } else {
            message.error(res.message)
          }
        }
      )
    } else {
      sendHttpPostRequest(
        'course/api/study_note/update_note/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          course_id: courseId,
          know_id: knowId,
          hash_id: note.hash_id,
          content: note.content,
          note_id: note.id,
          // image_id:note.image_id
        },
        (res) => {
          if (res.is_ok) {
            message.success('笔记更新成功！')
          } else {
            message.error(res.message)
          }
        }
      )
    }
    setEditorVis(false)
  }

  const onNoteContentChange = (indx, text ) => {
    noteList[indx].content = text
    setNoteList([...noteList])
  }

  const deleteNoteOk = () => {
    sendHttpPostRequest(
      'course/api/study_note/delete_note/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: courseId,
        know_id: knowId,
        hash_id: note.hash_id,
        content: note.content,
        note_id: note.id,
        // image_id:note.image_id
      },
      (res) => {
        if (res.is_ok) {
          message.success('笔记删除成功！')
          actionCallback(knowId)
        } else {
          message.error(res.message)
        }
      }
    )
    setDeleteNoteModalVis(false)
  }

  return (
    <div key={note.id} className={courseLearnStyles.noteCard}>

      <Row align={'middle'} justify={'start'}  wrap={false} style={{margin:'0 0 12px'}}>


        <Col
          flex={"auto"}
          style={{ textAlign:'left' }}
        >
          <div className={courseLearnStyles.noteCardVideoTime} onClick={jumpCurrentTime.bind(this, note.position)} >
            <Icon component={clockIcon}/>
            <span style={{ margin: '0px 5px' }}>
              {type == 2 ? '视频时间' : 'PDF页码'}
            </span>
            <span>
              {type == 2 ? secTotime(note.position) : note.position + 1}
            </span>
          </div>

        </Col>

        <Col flex={"100px"} style={{ textAlign:'right' }}>
          <div>

                <span
                  title="编辑"
                  className={slidesStyles.actionIconWrapper}
                  onClick={() => {
                  setEditorVis(true)
                  setIsEdit(true)
                }}
                >
                  <Icon component={editIcon}/>
                </span>
                <span title="删除" 
                  style={{marginLeft:0}}
                  className={slidesStyles.deleteIconWrapper} 
                  onClick={() => setDeleteNoteModalVis(true)}
                ><Icon component={mydeleteIcon}/></span> 


          </div>
        </Col>
      </Row>

      <Row wrap={false} align={"top"} >
        <Col flex={"320px"} style={{ textAlign:'left' }}>
          <div>
            <img
              src={constants.BACKEND_URL + note.image_src}
              width={312}
              height={200}
              style={{border:"1px solid #f3f5f7"}}
            />
          </div>
        </Col>

        <Col flex={"auto"} style={{ textAlign:'right' }}>
          <div >
            {!editorVis && <div className={courseLearnStyles.noteContent}  > {note.content} </div>}

            {editorVis && (
              <div >

                <TextArea maxLength={500} placeholder="请输入课程介绍" 
                    style={{borderRadius:8,width:"100%",fontSize:16,background:'#f9fafb', padding:'6px 12px', height:156}} 
                    defaultValue={note.content}
                    onChange={(e)=>{onNoteContentChange(nIdx ,e.target.value);}}
                    />
 
                <div style={{textAlign:'right', marginTop:8}} >
                  <span className={courseLearnStyles.saveNoteBtn} onClick={onNoteSave} > 保 存 </span>
                </div>
                

              </div>
            )}

          </div>
        </Col>
      </Row>

      <div className={courseLearnStyles.noteCardCreateTime}>
          笔记创建时间: {note.create_time}
      </div>

  

      <CommonModal
        onOk={deleteNoteOk}
        onCancel={() => setDeleteNoteModalVis(false)}
        width={350}
        modalContent={<div>确认删除这条笔记吗？</div>}
        open={deleteNoteModalVis}
        modalTitle={'提示'}
      />
    </div>
  )
}

export default NoteItem
